import script from "./VTextarea.vue?vue&type=script&setup=true&lang=ts"
export * from "./VTextarea.vue?vue&type=script&setup=true&lang=ts"

import "./VTextarea.vue?vue&type=style&index=0&id=96b42526&scoped=true&lang=postcss"

import exportComponent from "/builds/frontend/dsp/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96b42526"]])

export default __exports__